<template>
  <el-dialog
    title="修改内容"
    :visible="true"
    width="750px"
    @close="handleClose"
    :lock-scroll="false"
    :append-to-body="true"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <el-container>
      <el-main>
        <el-form :model="form" label-width="80px">
          <el-form-item label="标题">
            <el-input v-model="form.title" style="width:300px;"></el-input>
            <el-input-number v-model="form.sort" label="排序"></el-input-number>
          </el-form-item>
          <el-form-item label="内容">
            <kindeditor
              ref="child"
              :options="options"
              :value="inContent"
              @getcontent="getkindeditor"
            ></kindeditor>
          </el-form-item>
        </el-form>
      </el-main>
      <el-footer class="chead">
        <el-button type="primary" round @click="saveContent()">修改</el-button>
      </el-footer>
    </el-container>
  </el-dialog>
</template>
<script>
import config from "../../../api/config";
import Kindeditor from "../../../components/kindeditor";
import { editContent } from "../../../api/gm/api-content";
export default {
  data() {
    return {
      options: {
        width: "90%",
        height: "350px"
      },
      inContent: this.Content.info, //编辑器输入内容
      form: this.Content
    };
  },
  props: {
    Content: {
      type: Object
    }
  },
  components: {
    kindeditor: Kindeditor
  },

  methods: {
    //..关闭弹窗
    handleClose() {
      this.cleardata();
      this.$emit("hide");
    },
    //..获取富文本编辑器内容
    getkindeditor(val) {
      this.form.info = val;
      //this.$forceUpdate();
    },
    //..清楚内容
    cleardata() {
      this.form.id = 0;
      this.form.title = "";
      this.form.info = "";
      this.form.sort = 1;
      this.inContent = "";
      this.$refs.child.clear();
    },
    //..添加内容
    saveContent() {
      if (this.form.title.trim() === "") {
        this.$message.error("请输入标题");
      } else if (this.form.info.trim() === "") {
        this.$message.error("请输入内容");
      } else {
        let formData = new FormData();
        Object.keys(this.form).forEach(key => {
          if (this.form[key] !== null && this.form[key] !== undefined) {
            formData.append(key, this.form[key]);
          }
        });
        editContent(formData).then(res => {
          this.$emit("refresh");
          if (res.code === 0) {
            this.$confirm("修改成功,是否继续修改?", "提示", {
              confirmButtonText: "继续",
              cancelButtonText: "取消",
              type: "success",
              lockScroll: false,
              callback: action => {
                if (action !== "confirm") {
                  this.handleClose();
                }
              }
            });
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    }
  }
};
</script>
<style scoped>
.el-dialog {
  margin-top: 5vh !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/gm/content/edit.vue